export default "__VITE_ASSET__RN1p$8Bd__"